import React from 'react';
import { ClinicalSessionStep } from '@/dtos/FlowClinicalSessions/index';
import { BasePerson } from '@/dtos/Persons/index';
import { BasePerson as FlowBasePerson } from '@/dtos/FlowClinicalSessions/index';
import { User, HeartPulse, ClipboardList, FileText, CheckCircle2 } from 'lucide-react';

export interface SessionState {
  sessionId?: string;
  currentStepIndex: number;
  hasUnsavedChanges: boolean;
  selectedPerson: BasePerson | null;
  personFromResponse: FlowBasePerson | null;
}

export const STEPS: { key: ClinicalSessionStep; label: string; icon: React.ReactNode }[] = [
  { key: ClinicalSessionStep.Person, label: 'Date Personale', icon: React.createElement(User, { className: 'h-4 w-4' }) },
  { key: ClinicalSessionStep.Assessment, label: 'Evaluare', icon: React.createElement(ClipboardList, { className: 'h-4 w-4' }) },
  { key: ClinicalSessionStep.Results, label: 'Rezultate', icon: React.createElement(FileText, { className: 'h-4 w-4' }) },
  { key: ClinicalSessionStep.Guidance, label: 'Sumar', icon: React.createElement(CheckCircle2, { className: 'h-4 w-4' }) },
];
